'use client';

import { useEffect, useState } from 'react';

/** 读取当前视口底边在页面总高度中的位置，返回 1 到 100 的整数百分位。 */
export function getCurrentPageViewDepth(): number {
  if (typeof window === 'undefined' || typeof document === 'undefined') return 1;

  const documentHeight = Math.max(
    document.documentElement.scrollHeight,
    document.body?.scrollHeight ?? 0,
  );
  if (documentHeight <= 0) return 1;

  const viewportBottom = window.scrollY + window.innerHeight;
  return Math.min(100, Math.max(1, Math.ceil((viewportBottom / documentHeight) * 100)));
}

/**
 * 计算视口底边在页面总高度中的位置，返回 1 到 100 的整数百分位。
 */
export function usePageViewDepth(): number {
  const [depth, setDepth] = useState(1);

  useEffect(() => {
    const updateDepth = () => {
      setDepth(getCurrentPageViewDepth());
    };

    updateDepth();
    window.addEventListener('scroll', updateDepth, { passive: true });
    window.addEventListener('resize', updateDepth);

    return () => {
      window.removeEventListener('scroll', updateDepth);
      window.removeEventListener('resize', updateDepth);
    };
  }, []);

  return depth;
}
